import React from 'react';

const OrderSettlementInfo = ({ order }) => {
  if (order.commission_rate > 0) {
    return (
      <div className="bg-blue-50 border border-blue-100 rounded-lg p-3 text-sm">
        <p className="font-medium text-blue-700 mb-1">利润分配</p>
        <div className="flex justify-between text-blue-600">
          <span>总店佣金（{(order.commission_rate * 100).toFixed(1)}%）</span>
          <span>${parseFloat(order.commission_amount).toFixed(2)}</span>
        </div>
        <div className="flex justify-between text-green-600">
          <span>分店收入（含配送费）</span>
          <span>${parseFloat(order.branch_amount).toFixed(2)}</span>
        </div>
      </div>
    );
  }
  if (order.commission_rate == 0 && order.assigned_store_name) {
    return (
      <div className="bg-green-50 border border-green-100 rounded-lg p-3 text-sm">
        <p className="text-green-700">🏪 总店自行配送，全额收入 ${parseFloat(order.total_amount).toFixed(2)}</p>
      </div>
    );
  }
  return null;
};

export default OrderSettlementInfo;